// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  HAMBURGER: '[data-fragment="Header.hamburger"]',
  BACKDROP: '[data-fragment="Header.backdrop"]',
  ITEM: '[data-fragment="Header.item"]',
  MEGAMENU: '[data-fragment="Header.megamenu"]',
  MEGAMENU_BACK: '[data-fragment="Header.megamenuBack"]',
  FULLTEXT: '[data-fragment="Header.fulltext"]',
  CLOSE_FULLTEXT: '[data-fragment="Header.closeFulltext"]',
  FULLTEXT_TRIGGER: '[data-fragment="Header.fulltextTrigger"]',
  FULLTEXT_INPUT: '[data-fragment="Header.fulltextInput"]',
  FULLTEXT_BUTTON: '[data-fragment="Header.fulltextButton"]',
};

export default class Header extends WebComponent {
  constructor(props) {
    super(props);

    this.state = {
      menuOpened: false,
      headerHidden: false,
      activeMegamenu: null,
      fulltextOpened: false,
      backdropShown: false,
      overflowBackdropShown: false,
      megamenuOpened: false,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.openMegamenu = this.openMegamenu.bind(this);
    this.closeMegamenu = this.closeMegamenu.bind(this);
    this.openFulltext = this.openFulltext.bind(this);
    this.closeFulltext = this.closeFulltext.bind(this);
    this.showBackdrop = this.showBackdrop.bind(this);
    this.hideBackdrop = this.hideBackdrop.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    this.showMegamenuBackdrop = this.showMegamenuBackdrop.bind(this);
    this.hideMegamenuBackdrop = this.hideMegamenuBackdrop.bind(this);
	this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  didMount() {
    this.items = this.element.querySelectorAll(fragments.ITEM);
    this.megamenuBackLinks = this.element.querySelectorAll(fragments.MEGAMENU_BACK);
    this.megamenus = this.element.querySelectorAll(fragments.MEGAMENU);
    this.backdrop = this.element.querySelector(fragments.BACKDROP);
	this.hamburger = this.element.querySelector(fragments.HAMBURGER);
    this.on('click', fragments.HAMBURGER, this.toggleMenu);
    this.on('click', fragments.BACKDROP, this.handleBackdropClick);
    this.on('click', fragments.FULLTEXT_TRIGGER, this.openFulltext);
    this.on('click', fragments.CLOSE_FULLTEXT, this.closeFulltext);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('touchstart', this.handleTouchStart, false);
    document.addEventListener('touchmove', this.handleTouchMove, false);
	document.addEventListener('keydown', this.handleKeyDown, false);
    for (let i = 0; i < this.items.length; i++) {
      this.items[i].addEventListener('click', this.openMegamenu);
      this.items[i].addEventListener('mouseenter', this.showMegamenuBackdrop);
      this.items[i].addEventListener('mouseleave', this.hideMegamenuBackdrop);
    }
    for (let i = 0; i < this.megamenuBackLinks.length; i++) {
      this.megamenuBackLinks[i].addEventListener('click', this.closeMegamenu);
    }
    this.lastScrollY = 0;
    this.xDown = null;
    this.yDown = null;
  }

  toggleMenu = () => {
    const { menuOpened } = this.state;
	const newState = !menuOpened;
    this.setState({
      menuOpened: newState,
      activeMegamenu: null,
    });
	if (this.hamburger) {
	  this.hamburger.setAttribute('aria-expanded', newState ? 'true' : 'false');
	}
    if (menuOpened) {
      this.hideBackdrop();
    } else {
      this.showBackdrop();
    }
  };

  closeMenu = () => {
    this.setState({
      menuOpened: false,
      activeMegamenu: null,
    });
	if (this.hamburger) {
	  this.hamburger.setAttribute('aria-expanded', 'false');
	}
    this.hideBackdrop();
  };

  handleTouchStart = (e) => {
    const firstTouch = e.touches[0];
    this.xDown = firstTouch.clientX;
    this.yDown = firstTouch.clientY;
  };

  handleTouchMove = (e) => {
    if (!this.xDown || !this.yDown) {
      return;
    }
    const xUp = e.touches[0].clientX;
    const yUp = e.touches[0].clientY;
    const xDiff = this.xDown - xUp;
    const yDiff = this.yDown - yUp;
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff < 0) {
        if (this.state.activeMegamenu) {
          this.closeMegamenu();
        } else {
          this.closeMenu();
        }
      }
    }
    this.xDown = null;
  };

  handleScroll = () => {
    const scrollY = window.scrollY;
    if (window.scrollY > 100) {
      if (scrollY > this.lastScrollY) {
        this.setState({
          headerHidden: true,
        });
      } else {
        this.setState({
          headerHidden: false,
        });
      }
    }
    this.lastScrollY = scrollY <= 0 ? 0 : scrollY;
  };

  handleResize = () => {
    if (window.innerWidth > 1199 && this.state.menuOpened) {
      this.closeMenu();
    }
  };

  openMegamenu = (e) => {
    if (!this.state.activeMegamenu) {
      const megamenu = e.target.querySelector(fragments.MEGAMENU);
      this.setState({
        activeMegamenu: megamenu,
      });
    }
  };

  closeMegamenu = () => {
    this.setState({
      activeMegamenu: null,
    });
  };

	openFulltext = (e) => {
		this.setState({
			fulltextOpened: true,
		});
		this.showBackdrop();
		if (e && e.currentTarget) {
			e.currentTarget.setAttribute('aria-expanded', 'true');
		}
		setTimeout(() => {
			const input = this.element.querySelector(fragments.FULLTEXT_INPUT);
			const sendButton = this.element.querySelector(fragments.FULLTEXT_BUTTON);
			if (input) {
				input.setAttribute('tabindex', '0');
				sendButton.setAttribute('tabindex', '0');
				input.focus();
			}
		}, 0);
	};

	closeFulltext = () => {
		this.setState({
			fulltextOpened: false,
		});
		this.hideBackdrop();
		const trigger = this.element.querySelector(fragments.FULLTEXT_TRIGGER);
		if (trigger) {
			trigger.setAttribute('aria-expanded', 'false');
		}
		const input = this.element.querySelector(fragments.FULLTEXT_INPUT);
		const sendButton = this.element.querySelector(fragments.FULLTEXT_BUTTON);
		if (input) {
			input.setAttribute('tabindex', '-1');
			sendButton.setAttribute('tabindex', '-1');
		}
	};

	handleKeyDown = (e) => {
		if (e.key === 'Escape' && this.state.fulltextOpened) {
			this.closeFulltext();
		}
	};

  showBackdrop = () => {
    this.setState({
      backdropShown: true,
      overflowBackdropShown: true,
    });
  };

  hideBackdrop = () => {
    this.setState({
      backdropShown: false,
      overflowBackdropShown: false,
    });
  };

  handleBackdropClick = () => {
    this.closeMenu();
    this.closeFulltext();
  };

  showMegamenuBackdrop = (e) => {
    if (window.innerWidth > 991) {
      if (!e.target.classList.contains('header-nav__item--without-megamenu')) {
        this.setState({
          backdropShown: true,
        });
      }
    }
  };

  hideMegamenuBackdrop = () => {
    if (window.innerWidth > 991) {
      this.setState({
        backdropShown: false,
      });
    }
  };

  willUnMount() {
	  window.removeEventListener('scroll', this.handleScroll);
	  window.removeEventListener('resize', this.handleResize);
	  document.removeEventListener('touchstart', this.handleTouchStart, false);
	  document.removeEventListener('touchmove', this.handleTouchMove, false);
	  document.removeEventListener('keydown', this.handleKeyDown, false);
  }
  update() {
    const {
      menuOpened,
      headerHidden,
      activeMegamenu,
      backdropShown,
      overflowBackdropShown,
      fulltextOpened,
    } = this.state;
    classNames(this.element, { 'header--menu-opened': menuOpened });
    classNames(this.element, { 'header--hidden': headerHidden });
    classNames(this.element, { 'header--megamenu-active': activeMegamenu });
    classNames(this.element, { 'header--fulltext-opened': fulltextOpened });
    classNames(document.body, { 'overflow-full': overflowBackdropShown });
    classNames(this.backdrop, { 'header__backdrop--shown': backdropShown });
    if (activeMegamenu) {
      classNames(activeMegamenu, { 'megamenu--active': true });
    } else {
      for (let i = 0; i < this.megamenus.length; i++) {
        classNames(this.megamenus[i], { 'megamenu--active': false });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Header.js